import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { TestIdDirective } from '../../directives/test-id.directive';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
    selector: 'app-attribute-value-input',
    templateUrl: './attribute-value-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: AttributeValueInputComponent,
            multi: true
        }
    ],
    standalone: true,
    imports: [NgSwitch, NgSwitchCase, MatFormField, TestIdDirective, MatLabel, MatInput, ReactiveFormsModule, MatSelect, MatOption, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker]
})
export class AttributeValueInputComponent
  implements ControlValueAccessor, OnInit, OnDestroy
{
  @Input() set type(value: 'string' | 'number' | 'boolean' | 'date') {
    this._type = value;
    this.formControl.reset('');
    this.setValidatorsBasedOnType();
  }

  @Input() label: string;

  formControl = new FormControl();
  _type = 'string';
  onChange: any = () => null;
  onTouch: any = () => null;

  destroy$ = new Subject<void>();

  ngOnInit() {
    this.formControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.onChange(value);
        this.onTouch(value);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this.formControl.setValue(obj);
  }

  private setValidatorsBasedOnType() {
    switch (this._type) {
      case 'string':
        this.formControl.setValidators([]);
        break;
      case 'number':
        this.formControl.setValidators([
          Validators.pattern(/^-?(0|[1-9]\d*)?$/)
        ]);
        break;
      case 'boolean':
        this.formControl.setValidators([]);
        break;
      case 'date':
        this.formControl.setValidators([]);
    }
  }
}
